document.addEventListener("DOMContentLoaded", function () {
  const target = document.querySelector("#uploadery");

  const moveWidget = (el) => {
    target.appendChild(el);
  };

  const existing = document.querySelector("#uploadery-container");
  if (existing) {
    moveWidget(existing);
    return;
  }

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        const uploadContainer = Array.from(mutation.addedNodes).find((node) => {
          return node.nodeType === 1 && node.matches("#uploadery-container");
        });

        if (uploadContainer) {
          if (target) {
            moveWidget(uploadContainer);
            observer.disconnect();
          }
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
